import { SelectionGroupOption } from 'common/components';
import { Solution } from '../solution-card';

export const CABINET_SOLUTION_TAB_LIST: SelectionGroupOption[] = [
  { value: '1', text: 'Полки с ящиками' },
  { value: '2', text: 'Тумба с корзиной' },
  { value: '3', text: 'Подвесные полки' },
  { value: '4', text: 'Перегородка и пуф' },
  { value: '5', text: 'Стеллаж-перегородка' },
];

export const CABINET_SOLUTION_CONTENT_MAP: Record<string, Solution> = {
  '1': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/3-1.jpg/3-1.jpg',
    imgAlt: 'Полки с ящиками',
    title: `Полки с ящиками`,
    size: `108 × 144 × 32 см`,
    productIds: ['82731879', '82731875', '82731887', '82731907', '82036412'],
    '82731879': {
      productCount: 2,
    },
    '82731875': {
      productCount: 1,
    },
    '82731887': {
      productCount: 2,
    },
    '82731907': {
      productCount: 1,
    },
    '82036412': {
      productCount: 4,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-kabinet-polki-s-yashchikami',
  },
  '2': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/3-2.jpg/3-2.jpg',
    imgAlt: 'Тумба с корзиной',
    title: `Тумба с корзиной`,
    size: `105 × 111,6 × 32 см`,
    productIds: [
      '82731880',
      '82731908',
      '82731878',
      '82731910',
      '82020863',
      '82020864',
      '82731892',
      '82731904',
      '82731907',
    ],
    '82731880': {
      productCount: 1,
    },
    '82731908': {
      productCount: 1,
    },
    '82731878': {
      productCount: 1,
    },
    '82731910': {
      productCount: 2,
    },
    '82020863': {
      productCount: 1,
    },
    '82020864': {
      productCount: 2,
    },
    '82731892': {
      productCount: 2,
    },
    '82731904': {
      productCount: 2,
    },
    '82731907': {
      productCount: 1,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-kabinet-tumba-s-korzinoy',
  },
  '3': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/3-3.jpg/3-3.jpg',
    imgAlt: 'Подвесные полки',
    title: `Подвесные полки`,
    size: `Полки: 36 × 36 × 32 см; комбинация: 144 × 54 × 32 см`,
    productIds: ['82731908', '82731909', '82731878', '82731910', '82005978', '82020865', '82731898'],
    '82731908': {
      productCount: 4,
    },
    '82731909': {
      productCount: 1,
    },
    '82731878': {
      productCount: 1,
    },
    '82731910': {
      productCount: 3,
    },
    '82005978': {
      productCount: 2,
    },
    '82020865': {
      productCount: 1,
    },
    '82731898': {
      productCount: 1,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-kabinet-podvesnyye-polki',
  },
  '4': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/3-4.jpg/3-4.jpg',
    imgAlt: 'Перегородка и пуф',
    title: `Перегородка и пуф`,
    size: `Перегородка: 144 × 180 × 32 см; пуф: 36 × 36 × 32 см`,
    productIds: ['82010845', '82731882', '82731880', '82731879', '82731915', '82020865', '82731897'],
    '82010845': {
      productCount: 2,
    },
    '82731882': {
      productCount: 1,
    },
    '82731880': {
      productCount: 1,
    },
    '82731879': {
      productCount: 1,
    },
    '82731915': {
      productCount: 1,
    },
    '82020865': {
      productCount: 1,
    },
    '82731897': {
      productCount: 1,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-kabinet-peregorodka-i-puf',
  },
  '5': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/3-5.jpg/3-5.jpg',
    imgAlt: 'Стеллаж-перегородка',
    title: `Стеллаж-перегородка`,
    size: `180 × 129,6 × 32 см`,
    productIds: [
      '82731870',
      '82731915',
      '82731878',
      '82731869',
      '82005978',
      '82020863',
      '82020864',
      '82010844',
      '82731904',
      '82731906',
    ],
    '82731870': {
      productCount: 2,
    },
    '82731915': {
      productCount: 6,
    },
    '82731878': {
      productCount: 3,
    },
    '82731869': {
      productCount: 4,
    },
    '82005978': {
      productCount: 5,
    },
    '82020863': {
      productCount: 1,
    },
    '82020864': {
      productCount: 4,
    },
    '82010844': {
      productCount: 1,
    },
    '82731904': {
      productCount: 3,
    },
    '82731906': {
      productCount: 1,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-kabinet-stellazh-peregorodka',
  },
};
